import { Skeleton } from "@songtradr-one/components-frontend";
import { Flex } from "../../flex/Flex.Parts";
import { Props } from "./DateColumn.Parts";

export const DateColumnSkeleton = ({ className }: Props) => (
  <Flex className={className} $direction="column" $gap="0.5rem">
    <Skeleton $width="100%" $height="1rem" />
    <Skeleton $width="33%" $height="1rem" />
  </Flex>
);
